// extracted by mini-css-extract-plugin
export default {"tasks":"tasks_tasks__-mAZm","activeTasks":"tasks_activeTasks__y5iAH","historyTasks":"tasks_historyTasks__O-QXn","body":"tasks_body__Y8buK","filters":"tasks_filters__4AApl"};